(function () {
    'use strict';

    angular
        .module('invesfleet')
        .controller('ScheduledOrdersController', ScheduledOrdersController);

    ScheduledOrdersController.$inject = [
        '$scope',
        '$rootScope',
        'userService',
        'ordersService',
        '$templateCache',
        '$timeout',
        '$filter',
        'fleet',
        'preferences',
        '$state',
        'ModalService',
        'reportService',
        'aceptacionServicioService',
        'notificationService',
        'simpleModalService',
        'genericDataService',
        'common'
    ];

    /* jshint maxstatements:false, maxparams:false */
    function ScheduledOrdersController(
        $scope,
        $rootScope,
        userService,
        ordersService,
        $templateCache,
        $timeout,
        $filter,
        fleet,
        preferences,
        $state,
        ModalService,
        reportService,
        aceptacionServicioService,
        notificationService,
        simpleModalService,
        genericDataService,
        common
    ) {

        /* PRIVATE VARIABLES */
        var assignDriverTemplate = $templateCache.get('app/views/modals/assignDriverTemplate.html');
        var acceptServiceTemplate = $templateCache.get('app/views/modals/aceptacion/acceptServiceTemplate.html');
        var templatesBase = 'app/views/tablesTemplates/activeOrders/';
        var templates = {
            headerTemplate: $templateCache.get(templatesBase + 'headerTemplate.html'),
            headerCellTemplate: $templateCache.get(templatesBase + 'headerCellTemplate.html'),
            rowTemplate: $templateCache.get(templatesBase + 'scheduledRowTemplate.html'),
            estadoCellTemplateGRU: $templateCache.get(templatesBase + 'estadoCellTemplateGRU.html'),
            estadoCellTemplateTAX: $templateCache.get(templatesBase + 'estadoCellTemplateTAX.html'),
            drecogidaCellTemplate: $templateCache.get(templatesBase + 'dRecogidaCellTemplate.html'),
            dentregaCellTemplate: $templateCache.get(templatesBase + 'dEntregaCellTemplate.html'),
            accionesCellTemplate: $templateCache.get(templatesBase + 'accionesCellTemplate.html'),
            clienteCellTemplate: $templateCache.get(templatesBase + 'clienteCellTemplate.html'),
            choferCellTemplate: $templateCache.get(templatesBase + 'choferCellTemplate.html'),
            typeCellTemplate: $templateCache.get(templatesBase + 'typeOrderCellTemplate.html'),
            delayCellTemplate: $templateCache.get(templatesBase + 'delayCellTemplate.html'),
            vehicleCellTemplate: $templateCache.get(templatesBase + 'vehicleCellTemplate.html'),
            dateCellTemplate: $templateCache.get(templatesBase + 'dateCellTemplate.html'),
            observacionesCellTemplate: $templateCache.get(templatesBase + 'observacionesCellTemplate.html'),
        };

        var userConfig = userService.userData;

        var listeners = [];
        var timeouts = [];

        /* PUBLIC VARIABLES */
        var vm = this;

        vm.searchText = '';
        vm.clearSearcher = clearSearcher;

        vm.fleet = fleet;
        vm.isScheduled = true;
        vm.preferences = preferences;
        vm.rootScope = $rootScope;
        vm.aceptacionServicioService = aceptacionServicioService;
        
        //GRID
        $scope.gridData = null;
        vm.gridApi = null;
        
        $scope.gridOptions = {
            //headerTemplate: templates.headerTemplate,
            //headerCellTemplate: templates.headerCellTemplate,
            rowTemplate: templates.rowTemplate,
            enableGridMenu: true,
            enableColumnMenus: false,
            treeRowHeaderAlwaysVisible: false,

            //With virtualization we lower the number of watchers (9257 to 4970 with 67 orders for example)
            //Virtualization uses transform: translateY for each row which means that each row creates 
            //each own stacking context and our dropdown menus or any element using z-index wont work well..
            virtualizationThreshold: 200,

            //Row selection
            enableRowHeaderSelection: true,
            enableGroupHeaderSelection: true,
            enableRowSelection: false,
            enableSelectAll: true,
            multiSelect: true,
            enableColumnResizing: true,

            rowHeight: 26,

            primaryKey: 'orderId',
            columnDefs: computeColumnsByOrderType(),
            data: 'gridData',
            onRegisterApi: function (gridApi) {
                vm.gridApi = gridApi;

                vm.gridApi.selection.on.rowSelectionChanged($scope, function (row) {
                    var childRows, rowEntity, length, i;

                    if (row.internalRow === true && row.isSelected === true) {
                        childRows = row.treeNode.children;
                        for (i = 0, length = childRows.length; i < length; i++) {
                            rowEntity = childRows[i].row.entity;
                            vm.gridApi.selection.selectRow(rowEntity);
                        }
                    }

                    if (row.internalRow === true && row.isSelected === false) {
                        childRows = row.treeNode.children;
                        for (i = 0, length = childRows.length; i < length; i++) {
                            rowEntity = childRows[i].row.entity;
                            vm.gridApi.selection.unSelectRow(rowEntity);
                        }
                    }
                });

                vm.gridApi.grid.registerDataChangeCallback(function () {
                    angular.forEach(vm.gridApi.grid.grouping.groupingHeaderCache, function (value, key) {
                        if (!value.row.userSet) {
                            vm.gridApi.treeBase.expandRow(value.row);
                            vm.gridApi.selection.selectRow(value.row.entity);
                            value.row.userSet = true;
                        }
                    });
                });
            }
        };

        vm.operatorsList = [];
        vm.blurGrid = false;

        vm.filters = {
            logistic: null,
            programmed: null,
            delayed: null
        };


        vm.refreshing = false;
        vm.focusedRow = null;

        vm.nProgrammed = 0;
        vm.nDelayed = 0;
        vm.now = Date.NewDate().getTime();

        vm.reportService = reportService;

        /* PUBLIC FUNCTIONS */
        vm.getColorEstado = getColorEstado;
        vm.getTipoEstado = getTipoEstado;
        vm.getIconoOrden = getIconoOrden;
        vm.getTextoOrden = getTextoOrden;
        vm.getBrandLogo = getBrandLogo;
        vm.groupHeaderContent = groupHeaderContent;
        vm.groupHeaderContentDate = groupHeaderContentDate;
        vm.showAssignDriver = showAssignDriver;
        vm.loadData = loadData;
        vm.filterGridData = filterGridData;
        vm.getEstadoName = getEstadoName;
        vm.remove = remove;
        vm.assignOperatorToOrder = assignOperatorToOrder;
        vm.refreshData = refreshData;
        vm.selectAll = selectAll;
        vm.clearAll = clearAll;
        vm.invertSelection = invertSelection;
        vm.selectOrClear = selectOrClear;
        vm.changeOrderState = changeOrderState;
        vm.chatWithChofer = chatWithChofer;
        vm.acknowledgeDelay = acknowledgeDelay;
        vm.isGroupSelected = isGroupSelected;
        vm.groupSelect = groupSelect;
        vm.getRemainingTimeToAccept = getRemainingTimeToAccept;
        vm.goToEdit = goToEdit;
        vm.removeAllOrders = removeAllOrders;
        vm.getTextoEstadoAsig = getTextoEstadoAsig;
        vm.groupHeaderContentList = [];
        vm.goToOrdenNueva = goToOrdenNueva;
        vm.createObservacionesJson = createObservacionesJson;
        vm.formatDateFromTimestamp = formatDateFromTimestamp;
        vm.getFormattedTimeTooltip = getFormattedTimeTooltip;
        vm.selectGroupingFilter = {
            list: [
                {
                    id: 0,
                    nombre: 'Todas'
                },
                {
                    id: 1,
                    nombre: 'Programadas de hoy'
                }
            ],
            selected: {
                id: 0
            }
        };
        vm.data = [];
        vm.activarOrder = activarOrder;
        vm.activarOrders = activarOrders;
        
        vm.reloadListener = null;
        vm.rowCount = 0;

        /* INITIALIZER */
        (function () {

            vm.loadData();

            if (!preferences.loaded) { preferences.getCompanyPrefs(); }

            countTimeEachSecond();

            vm.reloadListener = $rootScope.$on('ReloadOrdenesProgramadas', function (event, args) {
                vm.refreshData();
            });

        })();

        //listeners.push($scope.$on('detail-resize', function (event, args) {            
        //    if ($rootScope.tabManager.tabs[$rootScope.tabManager.indexOfName('OrdenesActivas')].isActive()) { 
        //        timeouts.push($timeout(function () { vm.gridApi.core.handleWindowResize(); }, 0));
        //    }
        //}));

        //listeners.push($scope.$on('fleetdata-refreshed', function (event, args) {
        //    //Save selected rows to mantain the selection after refreshing the data
        //    var selected = vm.gridApi.selection.getSelectedRows();

        //    vm.setGridData();

        //    vm.clearAll();
        //    for (var i = 0; i < $scope.gridData.length; i++) {
        //        var found = $filter('filter')(selected, { 'orderId': $scope.gridData[i].orderId });
        //        if (found[0]) {
        //            vm.gridApi.grid.modifyRows($scope.gridData);
        //            vm.gridApi.selection.selectRow($scope.gridData[i]);
        //        }
        //    }
        //}));


        function computeColumnsByOrderType() {
            if (preferences.prefs.sector === 'GRU') {
                return [
                    {
                        field: 'insurerId',
                        displayName: '',
                        width: 35,
                        resizable: true,
                        enableHiding: false,
                        cellTemplate: templates.clienteCellTemplate
                    },
                    {
                        field: 'state',
                        displayName: '',
                        maxWidth: 55,
                        resizable: true,
                        cellTemplate: templates.estadoCellTemplateGRU,
                    },
                    {
                        field: 'id',
                        displayName: 'Nº Orden',
                        minWidth: 75,
                        maxWidth: 80,
                        resizable: true, 
                        visible: false
                    },
                    {
                        field: 'expediente',
                        displayName: 'Expediente',
                        minWidth: 80,
                        maxWidth: 100,
                        resizable: true
                    },
                    {
                        field: 'date',
                        displayName: 'Fecha',
                        minWidth: 80,
                        maxWidth: 110,
                        resizable: true,
                        cellClass: 'overflow',
                        cellTemplate: templates.dateCellTemplate,
                        sort: { priority: 1, direction: 'asc' }
                    },
                    {
                        field: 'tiempoRestante',
                        displayName: 'Restante',
                        minWidth: 80,
                        maxWidth: 100,
                        resizable: true,
                        cellTemplate: templates.delayCellTemplate,

                    },
                    {
                        field: 'pickupAddress',
                        displayName: 'Dirección de recogida',
                        minWidth: 120,
                        resizable: true,
                        cellClass: 'overflow',
                        cellTemplate: templates.drecogidaCellTemplate,
                        cellFilter: 'capitalize',
                        sortingAlgorithm: function (stateA, stateB, rowA, rowB) {
                            if (rowA.entity.pickupTown === rowB.entity.pickupTown) {
                                return 0;
                            }
                            else if (rowA.entity.pickupTown > rowB.entity.pickupTown) {
                                return 1;
                            } else {
                                return -1;
                            }
                        }
                    },
                    {
                        field: 'deliveryAddress',
                        displayName: 'Dirección de entrega',
                        minWidth: 120,
                        resizable: true,
                        cellClass: 'overflow',
                        cellTemplate: templates.dentregaCellTemplate,
                        cellFilter: 'capitalize',
                        sortingAlgorithm: function (stateA, stateB, rowA, rowB) {
                            if (rowA.entity.pickupTown === rowB.entity.pickupTown) {
                                return 0;
                            }
                            else if (rowA.entity.deliveryTown > rowB.entity.deliveryTown) {
                                return 1;
                            } else {
                                return -1;
                            }
                        }
                    },
                    {
                        field: 'brand',
                        displayName: 'Marca',
                        minWidth: 60,
                        maxWidth: 100,
                        resizable: true,
                        cellFilter: 'capitalize',
                    },
                    {
                        field: 'model',
                        displayName: 'Modelo',
                        minWidth: 65,
                        maxWidth: 100,
                        resizable: true,
                        cellFilter: 'capitalize',
                    },
                    {
                        field: 'plate',
                        displayName: 'Matrícula',
                        minWidth: 65,
                        maxWidth: 100,
                        resizable: true,
                    },
                    {
                        field: 'fault',
                        displayName: 'Avería',
                        minWidth: 60,
                        maxWidth: 100,
                        resizable: true,
                        cellFilter: 'capitalize'
                    },
                    {
                        field: 'fleetId',
                        displayName: 'Vehículo',
                        minWidth: 45,
                        maxWidth: 90,
                        resizable: true,
                        cellFilter: 'capitalize',
                        cellTemplate: templates.vehicleCellTemplate
                    },
                    {
                        field: 'observacionesInt',
                        displayName: 'Obs. Int.',
                        resizable: false,
                        cellClass: 'overflow',
                        cellTemplate: templates.observacionesCellTemplate
                    },
                    {
                        field: 'assignedDriver',
                        displayName: 'Chofer',
                        width: 70,
                        resizable: true,
                        cellTemplate: templates.choferCellTemplate,
                        cellFilter: 'capitalize'
                    },
                    {
                        field: 'schedulingGrouping',
                        grouping: { groupPriority: 0 },
                        enableHiding: false,
                        sort: { priority: 0, direction: 'asc' },
                        visible: false
                    },
                    {
                        name: 'acciones',
                        displayName: 'Acciones',
                        width: 200,
                        resizable: true,
                        cellClass: 'overflow',
                        cellTemplate: templates.accionesCellTemplate,
                        enableHiding: false,
                        enableSorting: false
                    }
                ];
            }
            else if (preferences.prefs.sector === 'TAX') {
                return [
                    {
                        field: 'insurerId',
                        displayName: '',
                        width: 35,
                        resizable: true,
                        enableHiding: false,
                        cellTemplate: templates.clienteCellTemplate
                    },
                    {
                        field: 'state',
                        displayName: '',
                        minWidth: 30,
                        maxWidth: 100,
                        resizable: true,
                        cellTemplate: templates.estadoCellTemplateTAX
                    },
                    {
                        field: 'id',
                        displayName: 'Nº Orden',
                        minWidth: 70,
                        maxWidth: 80,
                        resizable: true
                    },
                    {
                        field: 'expediente',
                        displayName: 'Expediente',
                        minWidth: 80,
                        maxWidth: 130,
                        resizable: true
                    },
                    {
                        field: 'date',
                        displayName: 'Fecha',
                        minWidth: 70,
                        maxWidth: 130,
                        resizable: true,
                        cellTemplate: templates.dateCellTemplate,
                        sort: { priority: 1, direction: 'asc' }
                    },
                    {
                        field: 'delayTime',
                        displayName: 'Restante',
                        minWidth: 80,
                        maxWidth: 100,
                        resizable: true,
                        cellTemplate: templates.delayCellTemplate,
                    },
                    {
                        field: 'pickupAddress',
                        displayName: 'Dirección de recogida',
                        minWidth: 140,
                        resizable: true,
                        cellClass: 'overflow',
                        cellTemplate: templates.drecogidaCellTemplate,
                        cellFilter: 'capitalize'
                    },
                    {
                        field: 'deliveryAddress',
                        displayName: 'Dirección de entrega',
                        minWidth: 140,
                        resizable: true,
                        cellClass: 'overflow',
                        cellTemplate: templates.dentregaCellTemplate,
                        cellFilter: 'capitalize',
                    },
                    {
                        field: 'plate',
                        displayName: 'Matrícula',
                        minWidth: 80,
                        maxWidth: 100,
                        resizable: true,
                    },
                    {
                        field: 'pax',
                        displayName: 'PAX',
                        minWidth: 80,
                        maxWidth: 100,
                        resizable: true,
                        visible: false
                    },
                    {
                        field: 'numVuelo',
                        displayName: 'Vuelo',
                        minWidth: 80,
                        maxWidth: 100,
                        resizable: true,
                        visible: false
                    },
                    {
                        field: 'equipajeL',
                        displayName: 'Grande',
                        minWidth: 80,
                        maxWidth: 100,
                        resizable: true,
                        visible: false
                    },
                    {
                        field: 'equipajeM',
                        displayName: 'Mediana',
                        minWidth: 80,
                        maxWidth: 100,
                        resizable: true,
                        visible: false
                    },
                    {
                        field: 'equipajeS',
                        displayName: 'Pequeña',
                        minWidth: 80,
                        maxWidth: 100,
                        resizable: true,
                        visible: false
                    },
                    {
                        field: 'numSillasGrupo1',
                        displayName: 'NumSillasGrupo1',
                        minWidth: 80,
                        maxWidth: 100,
                        resizable: true,
                        visible: false
                    },
                    {
                        field: 'numSillasGrupo2',
                        displayName: 'NumSillasGrupo2',
                        minWidth: 80,
                        maxWidth: 100,
                        resizable: true,
                        visible: false
                    },
                    {
                        field: 'numSillasGrupo3',
                        displayName: 'NumSillasGrupo3',
                        minWidth: 80,
                        maxWidth: 100,
                        resizable: true,
                        visible: false
                    },
                    {
                        field: 'numBolsasGolf',
                        displayName: 'Bolsa Golf',
                        minWidth: 80,
                        maxWidth: 100,
                        resizable: true,
                        visible: false
                    },
                    {
                        field: 'numBicicletas',
                        displayName: 'Bicicleta',
                        minWidth: 80,
                        maxWidth: 100,
                        resizable: true,
                        visible: false
                    },
                    {
                        field: 'numTransportines',
                        displayName: 'Transportin',
                        minWidth: 80,
                        maxWidth: 100,
                        resizable: true,
                        visible: false
                    },
                    {
                        field: 'fleetId',
                        displayName: 'Vehículo',
                        minWidth: 75,
                        maxWidth: 90,
                        resizable: true,
                        cellFilter: 'capitalize',
                        cellTemplate: templates.vehicleCellTemplate
                    },
                    {
                        field: 'assignedDriver',
                        displayName: 'Chofer',
                        width: 85,
                        resizable: true,
                        cellTemplate: templates.choferCellTemplate,
                        cellFilter: 'capitalize'
                    },
                    {
                        field: 'schedulingGrouping',
                        grouping: { groupPriority: 0 },
                        enableHiding: false,
                        sort: { priority: 0, direction: 'asc' },
                        visible: false
                    },
                    { 
                        field: 'observacionesInt',
                        displayName: 'Obs. Int.',
                        resizable: false,
                        width: 50,
                        cellClass: 'overflow',
                        cellTemplate: templates.observacionesCellTemplate
                    },
                    {
                        name: 'acciones',
                        displayName: 'Acciones',
                        width: 180,
                        resizable: true,
                        cellClass: 'overflow',
                        cellTemplate: templates.accionesCellTemplate,
                        enableHiding: false,
                        enableSorting: false
                    }
                ];
            }

        }

        function countTimeEachSecond() { //Update the time each second so angular refreshes it in the ui each second
            vm.now = Date.NewDate().getTime();
            timeouts.push($timeout(countTimeEachSecond, 1000));
        }

        function loadData() {
            vm.refreshing = true;
            vm.clearAll();
            ordersService.getScheduledOrders()
                .then(function (result) {

                    vm.rowCount = result.orders.length;
                    vm.firstLoaded = true;

                    vm.groupHeaderContentList = result.listGroups;
                    vm.data = result.orders;
                    vm.filterGridData();
                    vm.refreshing = false;
                });
        }

        function filterGridData() {
            $scope.gridData = $filter('filter')(vm.data, filterExpression, true);

            var filterInfo = {};
            //Search box (OR filter)
            if (preferences.prefs.sector === 'GRU') {
                filterInfo = {
                    expediente: vm.searchText,
                    clientName: vm.searchText,
                    plate: vm.searchText,
                    assignedDriver: vm.searchText,
                    fleetId: vm.searchText,
                    fault: vm.searchText,
                    model: vm.searchText,
                    brand: vm.searchText,
                    deliveryTown: vm.searchText,
                    deliveryAddress: vm.searchText,
                    pickupTown: vm.searchText,
                    pickupAddress: vm.searchText,
                };
            } else if (preferences.prefs.sector === 'TAX') {
                filterInfo = {
                    expediente: vm.searchText,
                    clientName: vm.searchText,
                    plate: vm.searchText,
                    assignedDriver: vm.searchText,
                    fleetId: vm.searchText,
                    fault: vm.searchText,
                    model: vm.searchText,
                    brand: vm.searchText,
                    deliveryTown: vm.searchText,
                    deliveryAddress: vm.searchText,
                    pickupTown: vm.searchText,
                    pickupAddress: vm.searchText,
                };
            }

            $scope.gridData = $filter('searchFilter')($scope.gridData, filterInfo, true);
        }

        function filterExpression(value, index, array) {

            var groupId = vm.selectGroupingFilter.selected.id;
            if (groupId !== 0) {
                if (value.schedulingGrouping !== 0) {
                    return false;
                }
            }

            if (preferences.prefs.sector === 'GRU') {

            } else if (preferences.prefs.sector === 'TAX') {

            }

            return true;
        }

        function refreshData(success) {
            vm.loadData(true);
        }

        function clearSearcher() {
            vm.searchText = '';
            filterGridData();
        }

        function selectAll() {
            vm.gridApi.selection.selectAllRows();
        }

        function clearAll() {
            if (vm.gridApi !== null) {
                vm.gridApi.selection.clearSelectedRows();
            }
        }

        function invertSelection() {
            var selected = vm.gridApi.selection.getSelectedRows();

            vm.selectAll();

            for (var i = 0; i < selected.length; i++) {
                vm.gridApi.selection.unSelectRow(selected[i]);
            }
        }

        function selectOrClear() {
            if (vm.gridApi.selection.getSelectAllState()) {
                vm.clearAll();
            } else {
                vm.selectAll();
            }
        }

        function getRemainingTimeToAccept(date, order) {
            var altaDate = new Date(order.altaDate);
            var compute = parseInt((date - altaDate.getTime()) / 1000);
            return (order.timeAsignation || 300) - compute;
        }

        function showAssignDriver(orderId, order) { //MODAL
            vm.operatorsList = [];
            fleet.getAssignableOperators(orderId).then(function (data) {
                vm.operatorsList = data;
            });

            ModalService.showModal({
                template: assignDriverTemplate,
                controller:
                function (close) {
                    var modal = this;
                    modal.parentScope = vm;

                    modal.companyName = order.clientName;
                    modal.companySrc = vm.getBrandLogo(order.insurerId);
                    modal.tMedio = order.vehicleType;

                    modal.cancel = function () {
                        $rootScope.blurry = false;
                        close();
                    };
                },
                controllerAs: 'modal'
            });
        }

        function assignOperatorToOrder(orderId, operatorId, state, modal, confirm) {
            if (operatorId == null) {
                simpleModalService.yesNoModal('Confirmación desasignar chofer',
                    '¿Desea desasignar el chofer de la orden?')
                    .then(function (result) {
                        if (result) {
                            ordersService.assignToOperator(null, orderId).then(function (result) {
                                vm.refreshData(true);
                            });
                        }
                    });
            } else {
                if (state !== 100 || confirm) {
                    vm.blurGrid = true;
                    ordersService.assignToOperator(operatorId, orderId).then(function (result) {
                        vm.modal1 = false;
                        vm.blurGrid = false;
                        vm.refreshData(true);
                        fleet.getMapData().then(function () {
                            if (modal) {
                                modal.cancel();
                            }
                        });
                    });
                }
            }
        }

        function remove(id) {
            if (id == null) { return; }
            simpleModalService.yesNoModal('Confirmación eliminar', '¿Desea eliminar la orden?')
                .then(function (result) {
                    if (result) {
                        notificationService.sendAppNotification({
                            message: 'Eliminando orden...',
                            positionY: 'top', positionX: 'right', delay: 3000, type: 'info'
                        });
                        ordersService.removeOrders([id]).then(
                            function () {
                                notificationService.sendAppNotification({
                                    message: 'Orden eliminada con éxito',
                                    positionY: 'top', positionX: 'right', delay: 3000, type: 'success'
                                });
                                vm.refreshData();
                            }, function () {
                                notificationService.sendAppNotification({
                                    message: 'Ha ocurrido un error al eliminar la orden',
                                    positionY: 'top', positionX: 'right', delay: null, type: 'error'
                                });
                                vm.refreshData();
                            });
                    }
                });
        }

        function changeOrderState(orderId, state) {
            ordersService.legacyChangeOrderState(orderId, state)
                .then(function () { refreshData(); });
        }

        function acknowledgeDelay(order) {
            ordersService.acknowledgeDelay(order.orderId).then(function (result) {
                vm.refreshData();
            });
        }

        function goToEdit(orderId) {
            vm.focusedRow = orderId;
            //var allOrdersOpen = null;
            //if (vm.rootScope.tabManager.indexOfName('ordenes') !== -1) {
            //   allOrdersOpen = true;
            //}
            //$state.go('flota.ordenes.editar', { 'id': orderId, 'allOrdersOpen': allOrdersOpen });
            $rootScope.tabManager.goToOrdenes(orderId);
        }

        function chatWithChofer(choferId) {
            $state.go('flota.chat', { 'id': choferId });
        }

        function groupHeaderContent(row, cols) {
            if (row.treeNode.aggregations[0].groupVal !== 99)
                return vm.groupHeaderContentList[row.treeNode.aggregations[0].groupVal].label;
            else
                return vm.groupHeaderContentList[vm.groupHeaderContentList.length - 1].label;
        }

        function groupHeaderContentDate(row, cols) {
            if (row.treeNode.aggregations[0].groupVal !== 99)
                return vm.groupHeaderContentList[row.treeNode.aggregations[0].groupVal].groupingFormattedDate;
            else
                return vm.groupHeaderContentList[vm.groupHeaderContentList.length - 1].groupingFormattedDate;
        }

        var lastIsGroupSelected = null;
        function isGroupSelected(row) {
            for (var i = 0; i < row.treeNode.children.length; i++) {
                if (!row.treeNode.children[i].row.isSelected) {
                    row.groupSelected = false;
                    
                    lastIsGroupSelected = false;
                    return false;
                }
            }

            if (!lastIsGroupSelected)
                lastIsGroupSelected = true;

            row.groupSelected = true;

            return true;
        }

        function groupSelect(row) {
            console.log('llega');
            angular.forEach(row.treeNode.children, function (value, key) {
                if (row.groupSelected) {
                    vm.gridApi.selection.unSelectRow(value.row.entity);
                } else {
                    vm.gridApi.selection.selectRow(value.row.entity);
                }
            });
        }

        function getColorEstado(estado) {
            return preferences.prefs.getStateColor(estado) || 'undefined';
        }

        function getTipoEstado(tipo) {
            return userConfig.literals.estadosOrden[tipo] || $filter('initials')(vm.getEstadoName(tipo));
            //return preferences.prefs.getStateDesc(tipo) || '-';
        }

        function getEstadoName(estado) {
            return preferences.prefs.getStateDesc(estado) || '-';
        }

        function getIconoOrden(tipo) {
            return userConfig.orders.iconoOrden[tipo] || 'undefined';
        }

        function getBrandLogo(tipo) {
            if (tipo === null) { return null; }
            return userConfig.brands.insurance[tipo] || null;
        }

        function getTextoOrden(tipo) {
            return userConfig.orders.textoOrden[tipo] || 'en';
        }

        function removeAllOrders() {
            simpleModalService.yesNoModal('Confirmación eliminar',
                '¿Desea eliminar las ' + vm.gridApi.selection.getSelectedCount() + ' ordernes seleccionadas?')
                .then(function (result) {
                    if (result) {
                        var orderIds = [];
                        var selected = vm.gridApi.selection.getSelectedRows();
                        for (var i = 0; i < selected.length; i++) {
                            orderIds.push(selected[i].orderId);
                        }
                        notificationService.sendAppNotification({
                            message: 'Eliminando ordenes...',
                            positionY: 'top', positionX: 'right', delay: 3000, type: 'info'
                        });
                        ordersService.removeOrders(orderIds)
                            .then(
                            function () {
                                vm.refreshData(true);
                                notificationService.sendAppNotification({
                                    message: 'Ordenes eliminadas con éxito',
                                    positionY: 'top', positionX: 'right', delay: 3000, type: 'success'
                                });
                            }, function () {
                                notificationService.sendAppNotification({
                                    message: 'Ha ocurrido un error al eliminar las ordenes',
                                    positionY: 'top', positionX: 'right', delay: null, type: 'error'
                                });
                            }
                            );
                    }
                });
        }

        function createObservacionesJson(entity, property, newProperty) {
            var observaciones = entity[property];
            if (!(observaciones !== null && typeof observaciones !== 'undefined' && observaciones !== '')) {
                entity[newProperty] = [];
            } else {
                try {
                    entity[newProperty] = JSON.parse(observaciones);
                } catch (e) {
                    entity[newProperty] = [
                        {
                            time: 0,
                            author: '',
                            text: observaciones,
                        }
                    ];
                }
            }
            return true;
        }

        function formatDateFromTimestamp(timestamp) {
            return common.formatDateFromTimestamp(timestamp / 1000);
        }

        function getFormattedTimeTooltip(date) {
            var m = moment(date)
            return m.format('HH:mm');
        }

        function activarOrder(order) {
            var orderId = order.orderId;
            ordersService.activateScheduledOrder(orderId)
                .then(function (result) {
                    vm.loadData(true);
                    notificationService.sendAppNotification({
                        message: 'Se ha activado una orden.',
                        positionY: 'top', positionX: 'right', delay: 3000, type: 'success'
                    });
                });
        }

        function activarOrders() {
            var orderIds = [];
            var selected = vm.gridApi.selection.getSelectedRows();
            for (var i = 0; i < selected.length; i++) {
                orderIds.push(selected[i].orderId);
            }
            if (orderIds.length > 0) {
                ordersService.activateScheduledOrders(orderIds)
                    .then(function (result) {
                        vm.loadData(true);
                        notificationService.sendAppNotification({
                            message: orderIds.length > 1 ? 'Se han activado ' + orderIds.length + ' órdenes.' : 'Se ha activado una orden.',
                            positionY: 'top', positionX: 'right', delay: 3000, type: 'success'
                        });
                    });
            }
        }

        $scope.$on('$destroy', function () {

            if (vm.reloadListener != null)
                vm.reloadListener();

            listeners.forEach(element => {
                element();
            });

            timeouts.forEach(element => {
                $timeout.cancel(element);
            });

        });

        function getTextoEstadoAsig(estadoAsig) {
            /*jshint maxcomplexity:false */
            switch (estadoAsig) {
                case 0:
                    return 'Pendiente aceptación';
                case 1:
                    return 'Aceptado pendiente confirmación';
                case 2:
                    return 'Rechazado pendiente confirmación';
                case 3:
                    return 'Rechazado timeout pendiente confirmación';
                case 4:
                    return 'Error reintentar';
                case 5:
                    return 'Error no reintentar';
                case 6:
                    return 'Rechazado colaborador desconectado pendiente confirmación';
                case 7:
                    return 'Aceptado sin confirmación';
                case 8:
                    return 'Modificado sin confirmación';
                case 9:
                    return 'Baja sin confirmación';
                case 10:
                    return 'Pendiente presupuesto';
                case 11:
                    return 'Pendiente aceptación presupuesto';
                case 100:
                    return 'Aceptado';
                case 101:
                    return 'Rechazado';
                case 102:
                    return 'Rechazado timeout';
                case 103:
                    return 'Rechazado colaborador desconectado';
                case 104:
                    return 'Modificado';
                case 105:
                    return 'Baja';
                case 106:
                    return 'Rechazado presupuesto';
                case 107:
                    return 'Aceptado presupuesto';
                default:
                    return '-';
            }
        }

        function goToOrdenNueva() {
            $rootScope.tabManager.goToOrdenes(null, true); // true, is "programada"
        }
    }
})();


